import React from 'react';
import './Dynamic.css'; 
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DynamicIsland = () => {
  return (
    <div className="dynamic-island">
      <p className="island-text">
        <FontAwesomeIcon icon={faCircle} size="2x"/>
      </p>
    </div>
  );
};

export default DynamicIsland;